// libs
import React from 'react';

export const Icon = ({ className = '' }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <rect width="24" height="24" fill="transparent" />
      <path
        d="M3 7L8.8521 12.8521L12.6862 9.01797L17.6639 13.9956"
        stroke="#068743"
        strokeWidth="1.30072"
      />
      <path
        d="M19.611 15.7718L17.2328 15.6478L14.8546 15.5237L16.8608 13.2956L18.8671 11.0675L19.239 13.4196L19.611 15.7718Z"
        fill="#068743"
        className="arrow"
      />
    </svg>
  );
};

export default Icon;
